let isBackgroundLoad = false;

export const getIsBackgroundLoad = (): boolean => isBackgroundLoad;

export const setIsBackgroundLoad = (newIsBackgroundLoad: boolean): void => {
  isBackgroundLoad = newIsBackgroundLoad;
};
